<template>
  <b-row>
    <b-col cols="12">
      <company-settings-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CompanySettingsEditForm from './CompanySettingsEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    CompanySettingsEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
